import type { JSX } from 'react'
import type { IDividerProps } from 'atoms/Divider'

import { Divider } from 'atoms/Divider'

export interface ITimeLineDivider extends IDividerProps {}

export const TimeLineDivider = ({
  ...props
}: ITimeLineDivider): JSX.Element => (
  <Divider height={'16px'} width={'1px'} {...props} />
)
